import { render } from "./TrekFooter.vue?vue&type=template&id=6cbb2f7b"
import script from "./TrekFooter.vue?vue&type=script&lang=js"
export * from "./TrekFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__